<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as OWNER_CONTACT_TYPES } from './store'
import { TYPES as CNT_ORG_TYPES } from '../../../organization-contact/store'
import { ROUTES as OWNER_ORG_ROUTES } from '../../../organization/organization/owner-organization/router'
import { ORGANIZATION_OWNER_TYPE_CODE } from '@/const'

import ContactDetailMixin from '../../../components/contact/mixins/ContactDetailMixin'

export default {
  name: 'OwnerContactDetail',
  mixins: [ContactDetailMixin],
  data () {
    return {
      OWNER_ORG_ROUTES,
      organizationTitle: 'Owner organization',
      routeNameOrganizationDetail: OWNER_ORG_ROUTES.OWNER_ORGANIZATION_DETAIL,
      title: 'Owner contact',
      titleList: 'Customer contacts',
      orgType: ORGANIZATION_OWNER_TYPE_CODE
    }
  },
  computed: {
    ...mapGetters({
      ...OWNER_CONTACT_TYPES.GENERIC.organization.ownercontact.DETAIL.GETTERS
    })
  },
  methods: {
    ...mapActions({
      ...OWNER_CONTACT_TYPES.GENERIC.organization.ownercontact.DETAIL.ACTIONS,
      getContactList: OWNER_CONTACT_TYPES.GENERIC.organization.ownercontact.LIST.ACTIONS.getList,
      createOrganizationContact: CNT_ORG_TYPES.GENERIC.organization.organizationcontact.DETAIL.ACTIONS.create
    }),
    goToOrganizationDetail () {
      this.$router.push({ name: OWNER_ORG_ROUTES.OWNER_ORGANIZATION_DETAIL, params: { id: this.$route.params.id } })
    }
  }
}
</script>
